import React from 'react';
import styled from 'styled-components';
import MainSlider from '../components/common/MainSlider';
import PostcodeCheck from '../components/common/PostcodeCheck';
import CategorySection from '../components/categories/CategorySection';
import ProductContainer from '../components/products/ProductContainer';
import SideMenu from '../components/categories/SideMenu';

const HomeWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const MainContent = styled.main`
  width: 100%;

  @media (min-width: 768px) {
    width: 75%;
    padding-left: 20px;
  }
`;

const SidebarWrapper = styled.aside`
  display: none;

  @media (min-width: 768px) {
    display: block;
    width: 25%;
  }
`;

const Section = styled.section`
  margin-bottom: 40px;
`;

const Home = () => {
  return (
    <HomeWrapper>
      <Section>
        <MainSlider />
      </Section>
      <Section>
        <PostcodeCheck />
      </Section>
      <ContentWrapper>
        <SidebarWrapper>
          <SideMenu />
        </SidebarWrapper>
        <MainContent>
          <Section>
            <CategorySection />
          </Section>
          <Section>
            <ProductContainer />
          </Section>
        </MainContent>
      </ContentWrapper>
    </HomeWrapper>
  );
};

export default Home;